import { useEffect, useRef, useState } from "react";
import { getVodSign } from "../utils/request";
import TCPlayer from "tcplayer.js";
import "tcplayer.js/dist/tcplayer.min.css";
import { useTcplayerCdn } from "../utils/tcplayerCdn";
export function useTCPlayer(fileID, isTCPVideo) {
  const containerRef = useRef(null);
  const playerRef = useRef(null);
  const [ready, setReady] = useState(false); // ⚡ 关键：当 ref 出现后触发 useEffect
  useTcplayerCdn()
  // 监听 containerRef 是否已经挂载到页面
  useEffect(() => {
    if (containerRef.current) {
      setReady(true); // 已经出现，直接标记 ready
      return;
    }

    // 如果还没出现，用 MutationObserver 等它出现
    const observer = new MutationObserver(() => {
      if (containerRef.current) {
        setReady(true);
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  // 主逻辑：只要 fileID 变化 或 ready === true 就执行
  useEffect(() => {
    if (!ready || !containerRef.current) {
      return;
    }

    if (!fileID) {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
      return;
    }

    getVodSign({ file_id: fileID }).then((res) => {
      const { signature, license_url } = res.data;
      console.log(playerRef.current, 'playerRef.current')
      if (playerRef.current) {
        playerRef.current.loadVideoByID({
          fileID,
          appID: "1251349076",
          psign: signature,
        });
      } else {
        playerRef.current = TCPlayer(containerRef.current, {
          fileID,
          appID: "1251349076",
          psign: signature,
          licenseUrl: license_url,
          width: "100%",
          height: "100%",
          bigPlayButton: false,
        });
        playerRef.current.on("resolutionswitching", () => {});
        playerRef.current.on("resolutionswitched", () => {});
      }
    });
  }, [fileID, ready]);

  // useEffect(() => {
  //   return () => {
  //     console.log(playerRef.current, 'unload')
  //     if (playerRef.current) {
  //       playerRef.current.dispose();
  //       playerRef.current = null;
  //     }
  //   };
  // }, []);

  return { containerRef, player: playerRef };
}
